import createReducer from 'reducers/createReducer';

import { ShopInfo } from 'actions/actionTypes';

const INITIAL_STATE = {
    data: {
        shopGuid: '',
        shopName: '',
        shopPhone: '',
        currency: '',
        country: '',
        zipcode: '',
        address1: '',
        address2: '',
        ownerName: '',
        ownerMobilePhoneCountry: '',
        ownerMobilePhone: '',
        ownerEmail: '',

        clientType: {
            screen: true,
            practice: false,
            lesson: false,
        },
        isSwingplate: true,
        isLeftHanded: false,
        isParking: false,
        isEquipmentStorage: false,
        isProLesson: false,
        operatingTime: '',
        operatingTimeImage: [],
        pricing: '',
        shopViewImage: [],
        parkingInformation: '',
        parkingInformationImage: [],
        shopIntroduction: '',
        shopIntroductionImage: [],

        clients: [],
        clientInfo: {
            clientGuid: '',
            clientName: '',
            clientOrder: 0,
            clientType: '',
        },
        shopLocations: {
            province: [],
            city: [],
            shopList: [],
        },
    },

    salesUpdate: {
        key: '',
        value: '',
    },

    error: {
        triggered: false,
        message: '',
    },
};

// 리듀서
const reducer = createReducer(INITIAL_STATE, {
    [ShopInfo.CHANGE_SHOP_INFO]: (state, action) => {
        state.data[action.payload.name] = action.payload.value;
    },
    [ShopInfo.CHANGE_SHOP_CLIENT_INFO_SETTING_GUID]: (state, action) => {
        if (action.payload.guid !== '') {
            state.data.clientInfo.clientGuid = action.payload.guid;

            const client = state.data.clients.find((p) => p.clientGuid === action.payload.guid);

            state.data.clientInfo.clientName = client.clientName;
            state.data.clientInfo.clientOrder = client.clientOrder;
            state.data.clientInfo.clientType = client.clientType;
        } else {
            state.data.clientInfo = INITIAL_STATE.data.clientInfo;
        }
    },
    [ShopInfo.CHANGE_SHOP_CLIENT_INFO]: (state, action) => {
        state.data.clientInfo[action.payload.name] = action.payload.value;
    },

    [ShopInfo.LOAD_SHOP_INFO_REQUEST]: (state, action) => {
        state.error = INITIAL_STATE.error;
    },
    [ShopInfo.LOAD_SHOP_INFO_REQUEST_SUCCESS]: (state, action) => {
        state.data.shopGuid = action.payload.shopGuid;
        state.data.shopName = action.payload.shopName;
        state.data.shopPhone = action.payload.shopPhone;
        state.data.currency = action.payload.currency;
        state.data.country = action.payload.country;
        state.data.zipcode = action.payload.zipcode;
        state.data.address1 = action.payload.address1;
        state.data.address2 = action.payload.address2;
        state.data.ownerName = action.payload.ownerName;
        state.data.ownerMobilePhoneCountry = action.payload.ownerMobilePhoneCountry;
        state.data.ownerMobilePhone = action.payload.ownerMobilePhone;
        state.data.ownerEmail = action.payload.ownerEmail;

        state.data.clientType = action.payload.clientType;
        state.data.isSwingplate = action.payload.isSwingplate;
        state.data.isLeftHanded = action.payload.isLeftHanded;
        state.data.isParking = action.payload.isParking;
        state.data.isEquipmentStorage = action.payload.isEquipmentStorage;
        state.data.isProLesson = action.payload.isProLesson;
        state.data.operatingTime = action.payload.operatingTime;
        state.data.operatingTimeImage = action.payload.operatingTimeImage;
        state.data.pricing = action.payload.pricing;
        state.data.shopViewImage = action.payload.shopViewImage;
        state.data.parkingInformation = action.payload.parkingInformation;
        state.data.parkingInformationImage = action.payload.parkingInformationImage;
        state.data.shopIntroduction = action.payload.shopIntroduction;
        state.data.shopIntroductionImage = action.payload.shopIntroductionImage;
    },
    [ShopInfo.LOAD_SHOP_INFO_REQUEST_FAILURE]: (state, action) => {
        state.error = {
            triggered: true,
            message: action.payload,
        };
    },

    [ShopInfo.LOAD_SHOP_CLIENT_LIST_REQUEST]: (state, action) => {
        state.error = INITIAL_STATE.error;
    },
    [ShopInfo.LOAD_SHOP_CLIENT_LIST_REQUEST_SUCCESS]: (state, action) => {
        state.data.clients = action.payload.clients;
    },
    [ShopInfo.LOAD_SHOP_CLIENT_LIST_REQUEST_FAILURE]: (state, action) => {
        state.error = {
            triggered: true,
            message: action.payload,
        };
    },

    [ShopInfo.EDIT_SHOP_INFO_REQUEST]: (state, action) => {
        state.error = INITIAL_STATE.error;
    },
    [ShopInfo.EDIT_SHOP_INFO_REQUEST_SUCCESS]: (state, action) => {},
    [ShopInfo.EDIT_SHOP_INFO_REQUEST_FAILURE]: (state, action) => {
        state.error = {
            triggered: true,
            message: action.payload,
        };
    },

    [ShopInfo.EDIT_SHOP_SALES_INFO_REQUEST]: (state, action) => {
        state.salesUpdate.key = action.payload.key;
        state.salesUpdate.value = action.payload.value;
    },
    [ShopInfo.EDIT_SHOP_SALES_INFO_REQUEST_SUCCESS]: (state, action) => {
        state.salesUpdate = INITIAL_STATE.salesUpdate;
    },
    [ShopInfo.EDIT_SHOP_SALES_INFO_REQUEST_FAILURE]: (state, action) => {
        state.error = {
            triggered: true,
            message: action.payload,
        };
    },

    [ShopInfo.EDIT_SHOP_SALES_IMAGE_REQUEST]: (state, action) => {
        state.salesUpdate.key = action.payload.key;
        state.salesUpdate.value = action.payload.value;
    },
    [ShopInfo.EDIT_SHOP_SALES_IMAGE_REQUEST_SUCCESS]: (state, action) => {
        state.salesUpdate = INITIAL_STATE.salesUpdate;
    },
    [ShopInfo.EDIT_SHOP_SALES_IMAGE_REQUEST_FAILURE]: (state, action) => {
        state.error = {
            triggered: true,
            message: action.payload,
        };
    },

    [ShopInfo.EDIT_SHOP_CLIENT_INFO_REQUEST]: (state, action) => {
        state.error = INITIAL_STATE.error;
    },
    [ShopInfo.EDIT_SHOP_CLIENT_INFO_REQUEST_SUCCESS]: (state, action) => {
        state.data.isClientInfoSettingOpen = false;

        state.data.clientInfo = INITIAL_STATE.data.clientInfo;
    },
    [ShopInfo.EDIT_SHOP_CLIENT_INFO_REQUEST_FAILURE]: (state, action) => {
        state.error = {
            triggered: true,
            message: action.payload,
        };
    },

    [ShopInfo.LOAD_SHOP_LOCATIONS_REQUEST]: (state, action) => {
        state.error = INITIAL_STATE.error;
    },
    [ShopInfo.LOAD_SHOP_LOCATIONS_REQUEST_SUCCESS]: (state, action) => {
        state.data.shopLocations.province = action.payload.province;
        state.data.shopLocations.city = action.payload.city;
    },
    [ShopInfo.LOAD_SHOP_LOCATIONS_REQUEST_FAILURE]: (state, action) => {
        state.error = {
            triggered: true,
            message: action.payload,
        };
    },

    [ShopInfo.LOAD_ALL_SHOP_LIST_REQUEST]: (state, action) => {
        state.error = INITIAL_STATE.error;
    },
    [ShopInfo.LOAD_ALL_SHOP_LIST_REQUEST_SUCCESS]: (state, action) => {
        state.data.shopLocations.shopList = action.payload.list;
    },
    [ShopInfo.LOAD_ALL_SHOP_LIST_REQUEST_FAILURE]: (state, action) => {
        state.error = {
            triggered: true,
            message: action.payload,
        };
    },
});

export default reducer;
